<template>
  <div class="graphic-iconographic-content" id="identidade-visual-grafismos-iconografico" data-search-anchor>
    <div class="graphic-iconographic-title-wrapper">
      <h1 class="graphic-iconographic-title-span">{{ graphicIconographicTitleSpan }}</h1>
      <h1 class="graphic-iconographic-title">{{ graphicIconographicTitle }}</h1>
    </div>
    <div class="description-graphic-iconographic-title-icons-wrapper">
      <div class="graphic-iconographic-icon-wrapper-first">
        <p class="graphic-iconographic-description">{{ graphicIconographicDescription1 }}</p>
      </div>

      <div class="graphic-iconographic-icon-wrapper-sec">
        <p class="graphic-iconographic-description">{{ graphicIconographicDescription2 }}</p>
      </div>
    </div>
    <div
      class="graphic-iconographic-card-item" style="margin-bottom: 1rem;"
      :style="{ backgroundImage: `url(${ImageSrc})` }"
    ></div>

    <div
      class="graphic-iconographic-card-item"
      :style="{ backgroundImage: `url(${ImageSrc2})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import GraphicPageMixin from '@/mixins/graphic-page-mixin'
import { GraphicPageStore } from '@/store/visual-identity-page/graphic-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class GraphicsIconographicSection extends Mixins(GraphicPageMixin) {
  graphicPageStore: PageStoreContract = getModule(GraphicPageStore, this.$store)

  get graphicIconographicTitleSpan(): string {
    return this.getElementTitle(8, 0)
  }

  get graphicIconographicTitle(): string {
    return this.getElementText(8, 0)
  }

  get graphicIconographicDescription1(): string {
    return this.getElementText(8, 1)
  }

  get graphicIconographicDescription2(): string {
    return this.getElementText(8, 2)
  }

  get ImageSrc(): string {
    return this.getElementMedia(8, 3)
  }

  get ImageSrc2(): string {
    return this.getElementMedia(8, 4)
  }

  async getGraphicPage(): Promise<void> {
    await this.graphicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.graphicPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.graphic-iconographic-content {
  display: grid;
  max-width: 1032px;
}

.graphic-iconographic-title-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.graphic-iconographic-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 5px;
  color: #b3b3b3;
}

.graphic-iconographic-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
}

.description-graphic-iconographic-title-icons-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: 51.2% 48.8%;  
}

.graphic-iconographic-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  margin-top: 0;

  width: 430px;
}

.graphic-iconographic-icon-wrapper-first {
  display: flex;
  align-items: center;
}

.graphic-iconographic-icon-wrapper-sec {
  display: flex;
  align-items: center;
}

.graphic-iconographic-icon-wrapper {
  display: flex;
  align-items: center;
}

.graphic-iconographic-icon-wrapper-thr {
  display: flex;
  align-items: center;
}

.graphic-iconographic-card-item {
  position: relative;
  width: 1032px;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

</style>
